import _UfpFormattedMessage from './UfpFormattedMessage'
import _UfpIntlProvider from './UfpIntlProvider'
import _UfpPrintCurrentLanguage from './UfpPrintCurrentLanguage'

export const UfpIntlProvider = _UfpIntlProvider
export const UfpFormattedMessage = _UfpFormattedMessage
export const UfpPrintCurrentLanguage = _UfpPrintCurrentLanguage
